var script_loaded = false;

function loadJSscripts() {
    if (!script_loaded) {
        //observer.disconnect();
        script_loaded = true;

        // Load lazy iframes
        document.querySelectorAll("iframe.lazy").forEach(t => {
            var datasrc = t.dataset.src;
            if (datasrc != null) {
                t.src = datasrc;
            }
        });

        // Load lazy scripts
        var scripts = document.getElementsByTagName("script");
        for (var i = 0; i < scripts.length; i++) {
            if (scripts[i].getAttribute("data-src") !== null) {
                scripts[i].setAttribute("src", scripts[i].getAttribute("data-src"));
                delete scripts[i].dataset.src;
            }
            if (scripts[i].getAttribute("type") === "text/lazyload") {
                var e = document.createElement("script");
                for (var a = 0; a < scripts[i].attributes.length; a++) {
                    var n = scripts[i].attributes[a];
                    e.setAttribute(n.name, n.value);
                }
                e.type = "text/javascript";
                e.innerHTML = scripts[i].innerHTML;
                var parent = scripts[i].parentNode;
                parent.removeChild(scripts[i]);
                parent.insertBefore(e, scripts[i]);
            }
        }

        // Load lazy stylesheets
        var links = document.getElementsByTagName("link");
        for (var j = 0; j < links.length; j++) {
            if (links[j].getAttribute("data-href") !== null) {
                links[j].setAttribute("href", links[j].getAttribute("data-href"));
                delete links[j].dataset.href;
            }
        }

        // Dispatch custom event after loading
        document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
    }
}

// Events that trigger the lazy load
var activityEvents = [
    "mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"
];

// Attach event listeners to trigger lazy loading
activityEvents.forEach(function(eventName) {
    window.addEventListener(eventName, loadJSscripts, false);
});

// Fallback for window.onload
if (window.addEventListener) {
    window.addEventListener("load", function() {}, false);
} else if (window.attachEvent) {
    window.attachEvent("onload", function() {});
} else {
    window.onload = (function() {});
}

//var script_loaded=!1;function loadJSscripts(){if(!script_loaded){observer.disconnect(),script_loaded=!0,document.querySelectorAll("iframe.lazy").forEach(t=>{datasrc=t.dataset.src,null!=datasrc&&(t.src=datasrc)});var t=document.getElementsByTagName("script");for(i=0;i<t.length;i++)if(null!==t[i].getAttribute("data-src")&&(t[i].setAttribute("src",t[i].getAttribute("data-src")),delete t[i].dataset.src),"text/lazyload"==t[i].getAttribute("type")){for(var e=document.createElement("script"),a=0;a<t[i].attributes.length;a++){var n=t[i].attributes[a];e.setAttribute(n.name,n.value)}e.type="text/javascript",e.innerHTML=t[i].innerHTML,t[i].parentNode.removeChild(t[i]),t[i].parentNode.insertBefore(e,t[i])}var r=document.getElementsByTagName("link");for(i=0;i<r.length;i++)null!==r[i].getAttribute("data-href")&&(r[i].setAttribute("href",r[i].getAttribute("data-href")),delete r[i].dataset.href);document.dispatchEvent(new CustomEvent("asyncLazyLoad"))}}var activityEvents=["mousedown","mousemove","keydown","scroll","touchstart","click","keypress","touchmove"];activityEvents.forEach(function(t){window.addEventListener(t,loadJSscripts,!1)}),window.addEventListener?window.addEventListener("load",function(){},!1):window.attachEvent?window.attachEvent("onload",function(){}):window.onload=(t=>{});